import React, { useEffect, useState } from "react";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import { IP } from "./../../../../internalServer";
import { useSelector } from "react-redux";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";

export default function SubmisshionByUpload({
  question,
  questionNo,
  setQuestionsAnswer,
  questionsAnswer,
  adaptive,
}) {
  const [responseAttach, setResponseAttach] = useState("");
  const [mideaviewer, setMideaviewer] = useState(false);
  const [answerLimit, setAnswerLimit] = useState(
    question?.type?.maxLimit ? question?.type?.maxLimit : 2500,
  );
  useEffect(() => {
    setAnswerLimit(question?.type?.maxLimit);
  }, [question?.type]);
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
    setIsOpen(null);
  };

  const handlePdfClick = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment);
      setMideaviewer(true);
    }, 100);
  };

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            {adaptive ? null : `Q${questionNo}.  `}
            {question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span
                  style={
                    index !== 0
                      ? { marginLeft: "30px", display: "inline-block" }
                      : {}
                  }
                >
                  {line}
                </span>
              </React.Fragment>
            ))}

            {question?.is_mandatory && (
              <span
                style={{
                  marginLeft: "20px",
                  color: "#AC1616",
                  fontSize: "10px",
                  fontWeight: "700",
                }}
              >
                *Mandatory
              </span>
            )}
          </div>
        </div>
        {question?.attachments?.length > 0 &&
          question.attachments.map((attachment, index) => {
            const fileExt = attachment?.split(".").pop()?.toLowerCase();
            const isImage = ["jpg", "jpeg", "png"].includes(fileExt);
            const isDOC = ["doc", "docx",].includes(fileExt);
            const isVideo = fileExt === "mp4";
            const isPdf = fileExt === "pdf";
            const fileName = attachment.replace(/^[^_]*_/, "");
            const shortName =
              fileName.length > 15
                ? fileName.substring(0, 15) + "..."
                : fileName;

            const icon =
              iconData?.find((i) => i.extension === fileExt)?.icon || "";

            const fullUrl = IP + attachment.replace(/^\./, "");

            return (
              <div key={index} className="mt-2">
                {/* 🖼 IMAGE */}
                {isImage && (
                  <img
                    src={fullUrl}
                    alt="Attachment"
                    className="mt-3 imageWidthAndHeight"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}
                  />
                )}

                {/* 🎥 VIDEO */}
                {isVideo && (
                  <div
                    className="d-flex pdfContainerPendingAssessment gap-2 p-2"
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="flex align-items-center">
                      <img className="" src={icon} alt="icon" />
                    </div>
                    <div className="w-100">
                      <div className="pdfNameAssessment" title={fileName}>
                        {shortName}
                      </div>
                    </div>
                  </div>
                )}

                {/* 📄 PDF */}
                {(isPdf || isDOC) && (
                  <div
                    className="mt-2"
                    onClick={() => handlePdfClick(attachment)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex pdfContainer gap-2 p-2">
                      <div className="d-flex align-items-center">
                        <img className="extention_icon" src={icon} alt="pdf" />
                      </div>
                      <div className="w-100">
                        <div className="pdfNameAssessment" title={fileName}>
                          {shortName}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 📁 OTHER FILE TYPES */}
                {!isImage && !isVideo && !isPdf && !isDOC && (
                  <a
                    href={`https://docs.google.com/gview?url=${encodeURIComponent(
                      fullUrl,
                    )}&embedded=true`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="d-flex pdfContainer gap-2 p-2">
                      <div className="d-flex align-items-center">
                        <img className="extention_icon" src={icon} alt="file" />
                      </div>
                      <div className="w-100">
                        <div
                          className="pdfName"
                          title={attachment.replace(/^[^_]*_/, "")}
                        >
                          {attachment.replace(/^[^_]*_/, "")}
                        </div>
                      </div>
                    </div>
                  </a>
                )}
              </div>
            );
          })}

        <div style={{ position: "relative" }} className="mt-3 mb-3">
          <textarea
            placeholder="Type to write your answer here."
            className="textInputQuestion p-3"
            maxLength={answerLimit}
            value={
              questionsAnswer.find((i) => i.question_id === question?.id)
                ?.description
            }
            onChange={(e) =>
              setQuestionsAnswer((prev) => {
                let updatedData = prev.map((item) => {
                  if (item.question_id === question?.id) {
                    return {
                      ...item,
                      description: e.target.value,
                    };
                  }
                  return item;
                });
                if (
                  !updatedData.some((item) => item.question_id === question?.id)
                ) {
                  updatedData.push({
                    question_id: question?.id,
                    description: e.target.value,
                  });
                }

                return updatedData;
              })
            }
          ></textarea>
          <div
            className="maxWordCount"
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
            }}
          >
            {
              questionsAnswer.find((i) => i.question_id === question?.id)
                ?.description?.length
            }
            /{answerLimit}
          </div>
        </div>
      </div>

      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
          responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}
